/* eslint-disable */
export default {
  _11_Space_Stars_Sky: '11_Space/Stars_Sky',
  _01_Title_Screen_BG: '01_Title Screen/BG',
  _03_Beach_Bch_BG: '03_Beach/Bch_BG',
  _08_Downtown_Zoom_In_Tree_and_Bench_Slct_BnchSt: '08_Downtown Zoom In/Tree and Bench/Slct_BnchSt',
  _07_Downtown_Stephen_Perspective: '07_Downtown/Stephen_Perspective',
  _02_Shape_Review_Shapes_Plane_Sqr: '02_Shape Review/Shapes/Plane_Sqr',
  _08_Downtown_Zoom_In_Blue_Building_BluBldg_Slct_Sqr1: '08_Downtown Zoom In/Blue Building/BluBldg_Slct_Sqr1',
  _10_Camping_Zoom_In_Trees_Slct_Tree1_Trnk: '10_Camping Zoom In/Trees/Slct_Tree1_Trnk',
  _05_Beach_Zoom_In_Seagull_Seagl_Leg_1: '05_Beach Zoom In/Seagull/Seagl_Leg_1',
  _12_Space_Zoom_In_Dome_Slct_Rctngl_Sd: '12_Space Zoom In/Dome/Slct_Rctngl_Sd',
  _03_Beach_Lifeguard_Stand_LGStnd_FlagPl: '03_Beach/Lifeguard Stand/LGStnd_FlagPl',
  _07_Downtown_Lt: '07_Downtown/Lt',
  _02_Shape_Review_Title_Title_I: '02_Shape Review/Title/Title_I',
  _Pop_ups_Btn_Cont1: 'Pop-ups/Btn_Cont1',
  _11_Space_Spc_Grnd: '11_Space/Spc_Grnd',
  _Pop_ups_Btn_NwGm2: 'Pop-ups/Btn_NwGm2',
  _03_Beach_Ground_Grass6: '03_Beach/Ground/Grass6',
  _Pop_ups_Prtcl_2: 'Pop-ups/Prtcl_2',
  _03_Beach_Ground_Grass1: '03_Beach/Ground/Grass1',
  _11_Space_Tnl_Shdw: '11_Space/Tnl_Shdw',
  _05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_RP: '05_Beach Zoom In/Lifeguard Stand/LGStnd_Slct_RP',
  _Pop_ups_Prtcl_3: 'Pop-ups/Prtcl_3',
  _03_Beach_Ground_Grass7: '03_Beach/Ground/Grass7',
  _Pop_ups_Prtcl_1: 'Pop-ups/Prtcl_1',
  _03_Beach_Ground_Grass5: '03_Beach/Ground/Grass5',
  _07_Downtown_Tree_and_Bench_Area_Flwr_Prpl: '07_Downtown/Tree and Bench Area/Flwr_Prpl',
  _07_Downtown_Tree_and_Bench_Area_Flwr_Blue: '07_Downtown/Tree and Bench Area/Flwr_Blue',
  _07_Downtown_Tree_and_Bench_Area_Flwr_Pch: '07_Downtown/Tree and Bench Area/Flwr_Pch',
  _03_Beach_Ground_Grass8: '03_Beach/Ground/Grass8',
  _05_Beach_Zoom_In_Seagull_Seagl_Eyes_1: '05_Beach Zoom In/Seagull/Seagl_Eyes_1',
  _03_Beach_Ground_Grass3: '03_Beach/Ground/Grass3',
  _03_Beach_Beachball_Bchbll_Shdw: '03_Beach/Beachball/Bchbll_Shdw',
  _03_Beach_Ground_Bch_Wvs: '03_Beach/Ground/Bch_Wvs',
  _07_Downtown_Tree_and_Bench_Area_TrshCan_Shdw: '07_Downtown/Tree and Bench Area/TrshCan_Shdw',
  _08_Downtown_Zoom_In_Green_Building_Slct_Rctngl: '08_Downtown Zoom In/Green Building/Slct_Rctngl',
  _02_Shape_Review_Shapes_Plane_Hex: '02_Shape Review/Shapes/Plane_Hex',
  _13_Completion_Color_Ltrs_You_Did_It_I: '13_Completion/Color/Ltrs_You Did It/I',
  _13_Completion_Color_Ltrs_You_Did_It_Exclmtn: '13_Completion/Color/Ltrs_You Did It/Exclmtn',
  _13_Completion_Color_Ltrs_All_Shapes_Found_Exclmtn_1: '13_Completion/Color/Ltrs_All Shapes Found/Exclmtn_1',
  _Buttons_Menu_Pop_Up_Btn_Back2_1: 'Buttons/Menu Pop-Up/Btn_Back2_1',
  _07_Downtown_Lt_Shdw: '07_Downtown/Lt_Shdw',
  _03_Beach_Seagull_Seagl_Ftprnts: '03_Beach/Seagull/Seagl_Ftprnts',
  _08_Downtown_Zoom_In_Green_Building_Slct_Wndw_1: '08_Downtown Zoom In/Green Building/Slct_Wndw_1',
  _Buttons_New_Game_Btn_No1: 'Buttons/New Game/Btn_No1',
  _13_Completion_Color_Ltrs_You_Did_It_D: '13_Completion/Color/Ltrs_You Did It/D',
  _13_Completion_Color_Ltrs_All_Shapes_Found_H: '13_Completion/Color/Ltrs_All Shapes Found/H',
  _13_Completion_Color_Ltrs_You_Did_It_U: '13_Completion/Color/Ltrs_You Did It/U',
  _13_Completion_Color_Ltrs_All_Shapes_Found_N: '13_Completion/Color/Ltrs_All Shapes Found/N',
  _13_Completion_Color_Ltrs_You_Did_It_T: '13_Completion/Color/Ltrs_You Did It/T',
  _13_Completion_Color_Ltrs_All_Shapes_Found_D_1: '13_Completion/Color/Ltrs_All Shapes Found/D_1',
  _05_Beach_Zoom_In_Sand_Castle_SndCstl_Slct_Clndr2: '05_Beach Zoom In/Sand Castle/SndCstl_Slct_Clndr2',
  _09_Camping_Tnt_Shdw: '09_Camping/Tnt_Shdw',
  _Buttons_New_Game_PopUp_NewGame: 'Buttons/New Game/PopUp_NewGame',
  _13_Completion_Color_Ltrs_All_Shapes_Found_A: '13_Completion/Color/Ltrs_All Shapes Found/A',
  _07_Downtown_Bldng_Blu_Shdw: '07_Downtown/Bldng_Blu_Shdw',
  _12_Space_Zoom_In_Greenhouse_Slct_PlntBx: '12_Space Zoom In/Greenhouse/Slct_PlntBx',
  _12_Space_Zoom_In_Dome_Slct_Penta1: '12_Space Zoom In/Dome/Slct_Penta1',
  _03_Beach_Chair_Shdw: '03_Beach/Chair_Shdw',
  _01_Title_Screen_PlayBtn_Top: '01_Title Screen/PlayBtn_Top',
  _10_Camping_Zoom_In_Chair_Slct_Arm: '10_Camping Zoom In/Chair/Slct_Arm',
  _12_Space_Zoom_In_Rover_Slct_Rf: '12_Space Zoom In/Rover/Slct_Rf',
  _02_Shape_Review_Shapes_Flat_Oval: '02_Shape Review/Shapes/Flat_Oval',
  _08_Downtown_Zoom_In_Tree_and_Bench_Slct_Grate: '08_Downtown Zoom In/Tree and Bench/Slct_Grate',
  _08_Downtown_Zoom_In_Tree_and_Bench_Trshcn: '08_Downtown Zoom In/Tree and Bench/Trshcn',
  _10_Camping_Zoom_In_Trees_Slct_Tree2_Trnk: '10_Camping Zoom In/Trees/Slct_Tree2_Trnk',
  _07_Downtown_Dwntwn_BG: '07_Downtown/Dwntwn_BG',
  _07_Downtown_Dntn_Grnd: '07_Downtown/Dntn_Grnd',
  _09_Camping_Evrgrn: '09_Camping/Evrgrn',
  _05_Beach_Zoom_In_Sand_Castle_SndCstl_Slct_Clndr1: '05_Beach Zoom In/Sand Castle/SndCstl_Slct_Clndr1',
  _05_Beach_Zoom_In_Sand_Castle_SndCstl_Slct_Cone: '05_Beach Zoom In/Sand Castle/SndCstl_Slct_Cone',
  _09_Camping_Cmp_Grnd: '09_Camping/Cmp_Grnd',
  _12_Space_Zoom_In_Dome_Slct_Penta2: '12_Space Zoom In/Dome/Slct_Penta2',
  _08_Downtown_Zoom_In_Peach_Building_Slct_Drs: '08_Downtown Zoom In/Peach Building/Slct_Drs',
  _09_Camping_Moon: '09_Camping/Moon',
  _09_Camping_Cmp_BG: '09_Camping/Cmp_BG',
  _03_Beach_Ground_Bch_Grnd: '03_Beach/Ground/Bch_Grnd',
  _05_Beach_Zoom_In_Seagull_Seagl_Hd: '05_Beach Zoom In/Seagull/Seagl_Hd',
  _02_Shape_Review_Shapes_Plane_Trngl: '02_Shape Review/Shapes/Plane_Trngl',
  _06_Menu_Pop_up_City_Badge: '06_Menu Pop-up/City_Badge',
  _06_Menu_Pop_up_Lock_Badge: '06_Menu Pop-up/Lock_Badge',
  _10_Camping_Zoom_In_Truck_Trk_1: '10_Camping Zoom In/Truck/Trk_1',
  _10_Camping_Zoom_In_Tent_Slct_TntSide: '10_Camping Zoom In/Tent/Slct_TntSide',
  _03_Beach_Instr_Popup: '03_Beach/Instr_Popup',
  _08_Downtown_Zoom_In_Tree_and_Bench_Bnch_1: '08_Downtown Zoom In/Tree and Bench/Bnch_1',
  _10_Camping_Zoom_In_Truck_Slct_Bmpr: '10_Camping Zoom In/Truck/Slct_Bmpr',
  _12_Space_Zoom_In_Rover_Slct_BkWndw: '12_Space Zoom In/Rover/Slct_BkWndw',
  _12_Space_Zoom_In_Dome_Slct_Rctngl_Top: '12_Space Zoom In/Dome/Slct_Rctngl_Top',
  _03_Beach_Ground_BchTwl: '03_Beach/Ground/BchTwl',
  _Buttons_Beach_Btn_Bch_Menu3: 'Buttons/Beach/Btn_Bch_Menu3',
  _04_Zoom_Shapes_Shp_Crcl: '04_Zoom Shapes/Shp_Crcl',
  _11_Space_Spc_BG: '11_Space/Spc_BG',
  _06_Menu_Pop_up_MnuPopUpBG: '06_Menu Pop-up/MnuPopUpBG',
  _08_Downtown_Zoom_In_Green_Building_Slct_Wall_1: '08_Downtown Zoom In/Green Building/Slct_Wall_1',
  _08_Downtown_Zoom_In_Peach_Building_Slct_Wall: '08_Downtown Zoom In/Peach Building/Slct_Wall',
  _08_Downtown_Zoom_In_Peach_Building_PchBldng: '08_Downtown Zoom In/Peach Building/PchBldng',
  _02_Shape_Review_Shapes_3D_Cube: '02_Shape Review/Shapes/3D_Cube',
  _06_Menu_Pop_up_Beach_Badge: '06_Menu Pop-up/Beach_Badge',
  _10_Camping_Zoom_In_Chair_Slct_Bk: '10_Camping Zoom In/Chair/Slct_Bk',
  _06_Menu_Pop_up_Camp_Badge: '06_Menu Pop-up/Camp_Badge',
  _06_Menu_Pop_up_Space_Badge: '06_Menu Pop-up/Space_Badge',
  _13_Completion_Color_Bdge_Lg_City: '13_Completion/Color/Bdge_Lg_City',
  _13_Completion_Print___Black_and_White_FinishedBnW: '13_Completion/Print - Black and White/FinishedBnW',
  _08_Downtown_Zoom_In_Blue_Building_BluBldng: '08_Downtown Zoom In/Blue Building/BluBldng',
  _10_Camping_Zoom_In_Chair_Chair_2: '10_Camping Zoom In/Chair/Chair_2',
  _05_Beach_Zoom_In_Seagull_Seagl_Slct_Hd: '05_Beach Zoom In/Seagull/Seagl_Slct_Hd',
  _06_Menu_Pop_up_Lock_BG: '06_Menu Pop-up/Lock_BG',
  _09_Camping_Fire_Fire_Shdw: '09_Camping/Fire/Fire_Shdw',
  _Buttons_Btn_City_Prgrs3: 'Buttons/Btn_City_Prgrs3',
  _13_Completion_Color_Ltrs_All_Shapes_Found_U_1: '13_Completion/Color/Ltrs_All Shapes Found/U_1',
  _02_Shape_Review_Title_Title_H: '02_Shape Review/Title/Title_H',
  _02_Shape_Review_Title_Title_R: '02_Shape Review/Title/Title_R',
  _13_Completion_Color_Ltrs_All_Shapes_Found_E: '13_Completion/Color/Ltrs_All Shapes Found/E',
  _08_Downtown_Zoom_In_Peach_Building_Slct_ChrBk: '08_Downtown Zoom In/Peach Building/Slct_ChrBk',
  _08_Downtown_Zoom_In_Tree_and_Bench_Gr8: '08_Downtown Zoom In/Tree and Bench/Gr8',
  _05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Step: '05_Beach Zoom In/Lifeguard Stand/LGStnd_Slct_Step',
  _12_Space_Zoom_In_Rover_Rvr_1: '12_Space Zoom In/Rover/Rvr_1',
  _05_Beach_Zoom_In_Beach_Ball_BchBll_Slct_Crcl: '05_Beach Zoom In/Beach Ball/BchBll_Slct_Crcl',
  _09_Camping_Fire_Fire_Stns_Bk: '09_Camping/Fire/Fire_Stns_Bk',
  _Buttons_Menu_Pop_Up_Btn_SndOn3: 'Buttons/Menu Pop-Up/Btn_SndOn3',
  _09_Camping_Fire_Fire_Wd: '09_Camping/Fire/Fire_Wd',
  _05_Beach_Zoom_In_Beach_Ball_BchBll_Slct_SmCrcl: '05_Beach Zoom In/Beach Ball/BchBll_Slct_SmCrcl',
  _01_Title_Screen_PlayBtn_Rt: '01_Title Screen/PlayBtn_Rt',
  _Buttons_New_Game_Btn_NewGame1: 'Buttons/New Game/Btn_NewGame1',
  _01_Title_Screen_PlayBtn_Lft: '01_Title Screen/PlayBtn_Lft',
  _09_Camping_Fire_Fire_Stns_Frnt: '09_Camping/Fire/Fire_Stns_Frnt',
  _03_Beach_Sand_Castle_Casl_Shdw: '03_Beach/Sand Castle/Casl_Shdw',
  _03_Beach_Ground_Grass9: '03_Beach/Ground/Grass9',
  _03_Beach_Lifeguard_Stand_LGStnd_Flag2: '03_Beach/Lifeguard Stand/LGStnd_Flag2',
  _03_Beach_Lifeguard_Stand_LGStnd_Flag1: '03_Beach/Lifeguard Stand/LGStnd_Flag1',
  _13_Completion_Color_Chk_CmpltLg: '13_Completion/Color/Chk_CmpltLg',
  _12_Space_Zoom_In_Greenhouse_Slct_Plnt1: '12_Space Zoom In/Greenhouse/Slct_Plnt1',
  _04_Zoom_Shapes_Shp_TringlrPrsm: '04_Zoom Shapes/Shp_TringlrPrsm',
  _04_Zoom_Shapes_Shp_TringlrPrsm_Ylw: '04_Zoom Shapes/Shp_TringlrPrsm_Ylw',
  _05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Flag: '05_Beach Zoom In/Lifeguard Stand/LGStnd_Slct_Flag',
  _03_Beach_Chair: '03_Beach/Chair',
  _12_Space_Zoom_In_Greenhouse_Grnhous_1: '12_Space Zoom In/Greenhouse/Grnhous_1',
  _08_Downtown_Zoom_In_Green_Building_GrnBldng: '08_Downtown Zoom In/Green Building/GrnBldng',
  _12_Space_Zoom_In_Greenhouse_Slct_Grnhous: '12_Space Zoom In/Greenhouse/Slct_Grnhous',
  _10_Camping_Zoom_In_Tent_Slct_TrnglrPrsm: '10_Camping Zoom In/Tent/Slct_TrnglrPrsm',
  _05_Beach_Zoom_In_Beach_Ball_BchBll: '05_Beach Zoom In/Beach Ball/BchBll',
  _06_Menu_Pop_up_Progress_R: '06_Menu Pop-up/Progress/R',
  _06_Menu_Pop_up_Progress_E_1: '06_Menu Pop-up/Progress/E_1',
  _06_Menu_Pop_up_Progress_G: '06_Menu Pop-up/Progress/G',
  _06_Menu_Pop_up_Progress_O_2: '06_Menu Pop-up/Progress/O_2',
  _08_Downtown_Zoom_In_Tree_and_Bench_Tree_1: '08_Downtown Zoom In/Tree and Bench/Tree_1',
  _05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Wndw1: '05_Beach Zoom In/Lifeguard Stand/LGStnd_Slct_Wndw1',
  _06_Menu_Pop_up_Progress_S_1: '06_Menu Pop-up/Progress/S_1',
  _13_Completion_Color_Ltrs_All_Shapes_Found_L: '13_Completion/Color/Ltrs_All Shapes Found/L',
  _03_Beach_Ground_PalmTrnk: '03_Beach/Ground/PalmTrnk',
  _02_Shape_Review_Title_Title_E: '02_Shape Review/Title/Title_E',
  _06_Menu_Pop_up_Progress_P_1: '06_Menu Pop-up/Progress/P_1',
  _Buttons_Menu_Pop_Up_Btn_Home1: 'Buttons/Menu Pop-Up/Btn_Home1',
  _02_Shape_Review_Title_Title_A: '02_Shape Review/Title/Title_A',
  _10_Camping_Zoom_In_Tent_Tent: '10_Camping Zoom In/Tent/Tent',
  _10_Camping_Zoom_In_Trees_Tree1: '10_Camping Zoom In/Trees/Tree1',
  _07_Downtown_Tree_and_Bench_Area_Bnch_Shdw: '07_Downtown/Tree and Bench Area/Bnch_Shdw',
  _02_Shape_Review_Shapes_Flat_Hexa: '02_Shape Review/Shapes/Flat_Hexa',
  _05_Beach_Zoom_In_Seagull_Seagl_Slct_Ft: '05_Beach Zoom In/Seagull/Seagl_Slct_Ft',
  _03_Beach_Ground_Grass2: '03_Beach/Ground/Grass2',
  _Pop_ups_Lock_ShckleCls: 'Pop-ups/Lock_ShckleCls',
  _05_Beach_Zoom_In_Sand_Castle_SndCastle: '05_Beach Zoom In/Sand Castle/SndCastle',
  _13_Completion_Color_Ltrs_You_Did_It_Y: '13_Completion/Color/Ltrs_You Did It/Y',
  _13_Completion_Color_Ltrs_You_Did_It_O: '13_Completion/Color/Ltrs_You Did It/O',
  _02_Shape_Review_Title_Title_V: '02_Shape Review/Title/Title_V',
  _12_Space_Zoom_In_Dome_Dome_1: '12_Space Zoom In/Dome/Dome_1',
  _13_Completion_Color_Ltrs_All_Shapes_Found_S: '13_Completion/Color/Ltrs_All Shapes Found/S',
  _13_Completion_Color_Ltrs_All_Shapes_Found_O_1: '13_Completion/Color/Ltrs_All Shapes Found/O_1',
  _11_Space_Rover_Rvr_Bdy: '11_Space/Rover/Rvr_Bdy',
  _05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Wndw2: '05_Beach Zoom In/Lifeguard Stand/LGStnd_Slct_Wndw2',
  _02_Shape_Review_Shapes_3D_Clndr: '02_Shape Review/Shapes/3D_Clndr',
  _10_Camping_Zoom_In_Trees_Slct_Tree1: '10_Camping Zoom In/Trees/Slct_Tree1',
  _08_Downtown_Zoom_In_Tree_and_Bench_Slct_TrshCan: '08_Downtown Zoom In/Tree and Bench/Slct_TrshCan',
  _02_Shape_Review_Title_Title_W: '02_Shape Review/Title/Title_W',
  _05_Beach_Zoom_In_Seagull_Seagl_Bdy: '05_Beach Zoom In/Seagull/Seagl_Bdy',
  _02_Shape_Review_Shapes_Plane_Crsnt: '02_Shape Review/Shapes/Plane_Crsnt',
  _10_Camping_Zoom_In_Truck_Slct_SdWndw: '10_Camping Zoom In/Truck/Slct_SdWndw',
  _Pop_ups_Btn_NwGm1: 'Pop-ups/Btn_NwGm1',
  _10_Camping_Zoom_In_Truck_Slct_Roof: '10_Camping Zoom In/Truck/Slct_Roof',
  _04_Zoom_Shapes_Shp_Clndr: '04_Zoom Shapes/Shp_Clndr',
  _13_Completion_Color_HldngShp_CmpltLg: '13_Completion/Color/HldngShp_CmpltLg',
  _04_Zoom_Shapes_Shp_Cone: '04_Zoom Shapes/Shp_Cone',
  _Pop_ups_PopUp_GrtWrkBG: 'Pop-ups/PopUp_GrtWrkBG',
  _Buttons_New_Game_Btn_Yes1: 'Buttons/New Game/Btn_Yes1',
  _08_Downtown_Zoom_In_Peach_Building_Slct_Wndw: '08_Downtown Zoom In/Peach Building/Slct_Wndw',
  _Buttons_Menu_Pop_Up_Btn_SndOff1: 'Buttons/Menu Pop-Up/Btn_SndOff1',
  _Buttons_Menu_Pop_Up_Btn_SndOn1: 'Buttons/Menu Pop-Up/Btn_SndOn1',
  _02_Shape_Review_Shapes_Plane_Octa: '02_Shape Review/Shapes/Plane_Octa',
  _Pop_ups_Btn_Cont2: 'Pop-ups/Btn_Cont2',
  _02_Shape_Review_Shapes_Plane_Penta: '02_Shape Review/Shapes/Plane_Penta',
  _08_Downtown_Zoom_In_Green_Building_Slct_RfLg: '08_Downtown Zoom In/Green Building/Slct_RfLg',
  _02_Shape_Review_Title_Title_S: '02_Shape Review/Title/Title_S',
  _Buttons_Print_Btn_Print2: 'Buttons/Print/Btn_Print2',
  _12_Space_Zoom_In_Greenhouse_Slct_Plnt1_1: '12_Space Zoom In/Greenhouse/Slct_Plnt1_1',
  _Pop_ups_Lock_ShckleOpn: 'Pop-ups/Lock_ShckleOpn',
  _10_Camping_Zoom_In_Trees_Tree2: '10_Camping Zoom In/Trees/Tree2',
  _04_Zoom_Shapes_Shp_Clndr_Ylw: '04_Zoom Shapes/Shp_Clndr_Ylw',
  _Buttons_Beach_Btn_Bch_Scene2: 'Buttons/Beach/Btn_Bch_Scene2',
  _02_Shape_Review_Shapes_Plane_Rctngl: '02_Shape Review/Shapes/Plane_Rctngl',
  _12_Space_Zoom_In_Rover_Slct_Tire: '12_Space Zoom In/Rover/Slct_Tire',
  _11_Space_Rover_Rvr_BkTire: '11_Space/Rover/Rvr_BkTire',
  _03_Beach_Lifeguard_Stand_LGStnd_Shdw: '03_Beach/Lifeguard Stand/LGStnd_Shdw',
  _09_Camping_Fire_Fire_Flm: '09_Camping/Fire/Fire_Flm',
  _02_Shape_Review_Shapes_Plane_Hrt: '02_Shape Review/Shapes/Plane_Hrt',
  _03_Beach_Ground_Grass4: '03_Beach/Ground/Grass4',
  _Buttons_Camp_Btn_Cmp_Scene2: 'Buttons/Camp/Btn_Cmp_Scene2',
  _Buttons_Menu_Pop_Up_Btn_Back1: 'Buttons/Menu Pop-Up/Btn_Back1',
  _Buttons_Menu_Pop_Up_Btn_SndOn2: 'Buttons/Menu Pop-Up/Btn_SndOn2',
  _02_Shape_Review_Shapes_Plane_Crcl: '02_Shape Review/Shapes/Plane_Crcl',
  _05_Beach_Zoom_In_Chkmrk: '05_Beach Zoom In/Chkmrk',
  _08_Downtown_Zoom_In_Tree_and_Bench_Slct_BnchBk: '08_Downtown Zoom In/Tree and Bench/Slct_BnchBk',
  _04_Zoom_Shapes_Shp_Prmd: '04_Zoom Shapes/Shp_Prmd',
  _Buttons_City_Btn_City_Scene2: 'Buttons/City/Btn_City_Scene2',
  _08_Downtown_Zoom_In_Green_Building_Slct_Ldge: '08_Downtown Zoom In/Green Building/Slct_Ldge',
  _03_Beach_Ground_PalmTop: '03_Beach/Ground/PalmTop',
  _10_Camping_Zoom_In_Truck_Slct_TailLt: '10_Camping Zoom In/Truck/Slct_TailLt',
  _04_Zoom_Shapes_Shp_RctPrsm: '04_Zoom Shapes/Shp_RctPrsm',
  _04_Zoom_Shapes_Shp_Prmd_Ylw: '04_Zoom Shapes/Shp_Prmd_Ylw',
  _04_Zoom_Shapes_Shp_RctPrsm_Ylw: '04_Zoom Shapes/Shp_RctPrsm_Ylw',
  _Tutorial_Arw_Lft: 'Tutorial/Arw_Lft',
  _Tutorial_Arw_Rt: 'Tutorial/Arw_Rt',
  _10_Camping_Zoom_In_Truck_Slct_Tire: '10_Camping Zoom In/Truck/Slct_Tire',
  _05_Beach_Zoom_In_Lifeguard_Stand_LGStnd_Slct_Roof: '05_Beach Zoom In/Lifeguard Stand/LGStnd_Slct_Roof',
  _10_Camping_Zoom_In_Trees_Slct_Cone: '10_Camping Zoom In/Trees/Slct_Cone',
  _03_Beach_Lifeguard_Stand_LGStnd: '03_Beach/Lifeguard Stand/LGStnd',
  _12_Space_Zoom_In_Greenhouse_Slct_GrnhousFrnt: '12_Space Zoom In/Greenhouse/Slct_GrnhousFrnt',
  _Pop_ups_PopUp_Cont: 'Pop-ups/PopUp_Cont',
  _10_Camping_Zoom_In_Chair_Slct_St: '10_Camping Zoom In/Chair/Slct_St',
  _08_Downtown_Zoom_In_Green_Building_Slct_RfSm: '08_Downtown Zoom In/Green Building/Slct_RfSm',
  _10_Camping_Zoom_In_Tent_Slct_TntFrnt: '10_Camping Zoom In/Tent/Slct_TntFrnt',
  _Pop_ups_PopUp_UnlockBG: 'Pop-ups/PopUp_UnlockBG',
  _Pop_ups_PopUp_NewGm: 'Pop-ups/PopUp_NewGm',
  _Pop_ups_PopUp_GrtWrk: 'Pop-ups/PopUp_GrtWrk',
  _08_Downtown_Zoom_In_Tree_and_Bench_Slct_Tre: '08_Downtown Zoom In/Tree and Bench/Slct_Tre',
  _12_Space_Zoom_In_Rover_Slct_SdWndw: '12_Space Zoom In/Rover/Slct_SdWndw',
  _11_Space_Rover_Rvr_Shdw: '11_Space/Rover/Rvr_Shdw',
  _13_Completion_Color_Bdge_Lg_Bch: '13_Completion/Color/Bdge_Lg_Bch',
  _12_Space_Zoom_In_Dome_Slct_Hex2: '12_Space Zoom In/Dome/Slct_Hex2',
  _13_Completion_Color_Bdge_Lg_Camp: '13_Completion/Color/Bdge_Lg_Camp',
  _13_Completion_Color_Bdge_Lg_Spc: '13_Completion/Color/Bdge_Lg_Spc',
  _09_Camping_Chair_Shdw_2: '09_Camping/Chair_Shdw_2',
  _01_Title_Screen_Title_E: '01_Title Screen/Title_E',
  _01_Title_Screen_Title_T: '01_Title Screen/Title_T',
  _01_Title_Screen_Title_G: '01_Title Screen/Title_G',
  _01_Title_Screen_Title_A: '01_Title Screen/Title_A',
  _01_Title_Screen_Title_H: '01_Title Screen/Title_H',
  _01_Title_Screen_Title_S: '01_Title Screen/Title_S',
  _12_Space_Zoom_In_Dome_Slct_Hex1: '12_Space Zoom In/Dome/Slct_Hex1',
  _10_Camping_Zoom_In_Truck_Slct_BkWndw: '10_Camping Zoom In/Truck/Slct_BkWndw',
  _12_Space_Zoom_In_Dome_Slct_Hex3: '12_Space Zoom In/Dome/Slct_Hex3',
  _01_Title_Screen_Title_P: '01_Title Screen/Title_P',
  _11_Space_Dome_Shdw: '11_Space/Dome_Shdw',
  _02_Shape_Review_Shapes_3D_TrnglPrsm: '02_Shape Review/Shapes/3D_TrnglPrsm',
  _02_Shape_Review_Shapes_3D_RctPrsm: '02_Shape Review/Shapes/3D_RctPrsm',
  _02_Shape_Review_Shapes_3D_Prmd: '02_Shape Review/Shapes/3D_Prmd',
  _11_Space_Tnl: '11_Space/Tnl',
  _02_Shape_Review_Shapes_Flat_Rctngl: '02_Shape Review/Shapes/Flat_Rctngl',
  _02_Shape_Review_Shapes_Flat_Trngl: '02_Shape Review/Shapes/Flat_Trngl',
  _01_Title_Screen_Title_IN: '01_Title Screen/Title_IN',
  _09_Camping_Fire_Fire_Glow: '09_Camping/Fire/Fire_Glow',
  _04_Zoom_Shapes_Shp_Cone_Ylw: '04_Zoom Shapes/Shp_Cone_Ylw',
  _02_Shape_Review_Shapes_3D_Cone: '02_Shape Review/Shapes/3D_Cone',
  _02_Shape_Review_Shapes_Plane_Oval: '02_Shape Review/Shapes/Plane_Oval',
  _02_Shape_Review_Shapes_Flat_Hrt: '02_Shape Review/Shapes/Flat_Hrt',
  _11_Space_Rover_Rvr_FrntTire: '11_Space/Rover/Rvr_FrntTire',
  _04_Zoom_Shapes_Shp_Hex: '04_Zoom Shapes/Shp_Hex',
  _Buttons_Menu_Pop_Up_Btn_Home2: 'Buttons/Menu Pop-Up/Btn_Home2',
  _04_Zoom_Shapes_Shp_Hex_Ylw: '04_Zoom Shapes/Shp_Hex_Ylw',
  _04_Zoom_Shapes_Shp_Penta: '04_Zoom Shapes/Shp_Penta',
  _04_Zoom_Shapes_Shp_Penta_Ylw: '04_Zoom Shapes/Shp_Penta_Ylw',
  _02_Shape_Review_Shapes_3D_Sphere: '02_Shape Review/Shapes/3D_Sphere',
  _02_Shape_Review_Shapes_Flat_Octa: '02_Shape Review/Shapes/Flat_Octa',
  _02_Shape_Review_Shapes_Flat_Penta: '02_Shape Review/Shapes/Flat_Penta',
  _10_Camping_Zoom_In_Trees_Slct_Shrb: '10_Camping Zoom In/Trees/Slct_Shrb',
  _Buttons_Btn_Cmp_Prgrs3: 'Buttons/Btn_Cmp_Prgrs3',
  _02_Shape_Review_Shapes_Flat_Crcl: '02_Shape Review/Shapes/Flat_Crcl',
  _02_Shape_Review_Shapes_Flat_Sqr: '02_Shape Review/Shapes/Flat_Sqr',
  _Buttons_Btn_Spc_Prgrs3: 'Buttons/Btn_Spc_Prgrs3',
  _02_Shape_Review_Shapes_Flat_Crsnt: '02_Shape Review/Shapes/Flat_Crsnt',
  _10_Camping_Zoom_In_Trees_Shrb_1: '10_Camping Zoom In/Trees/Shrb_1',
  _Buttons_Camp_Btn_Cmp_Menu3: 'Buttons/Camp/Btn_Cmp_Menu3',
  _Buttons_Shape_Review_Btn_Menu3: 'Buttons/Shape Review/Btn_Menu3',
  _07_Downtown_Tree_and_Bench_Area_Tree_Shdw: '07_Downtown/Tree and Bench Area/Tree_Shdw',
  _04_Zoom_Shapes_Shp_Trngl: '04_Zoom Shapes/Shp_Trngl',
  _Buttons_Print_Btn_Print3: 'Buttons/Print/Btn_Print3',
  _04_Zoom_Shapes_Shp_Trngl_1: '04_Zoom Shapes/Shp_Trngl_1',
  _04_Zoom_Shapes_Shp_Rct_Ylw: '04_Zoom Shapes/Shp_Rct_Ylw',
  _Buttons_City_Btn_City_Menu3: 'Buttons/City/Btn_City_Menu3',
  _Buttons_Space_Btn_Spc_Menu3: 'Buttons/Space/Btn_Spc_Menu3',
  _Buttons_Btn_Prgrs3: 'Buttons/Btn_Prgrs3',
  _Pop_ups_Btn_Cont3: 'Pop-ups/Btn_Cont3',
  _Pop_ups_Btn_NwGm3: 'Pop-ups/Btn_NwGm3',
  _04_Zoom_Shapes_Shp_Rct: '04_Zoom Shapes/Shp_Rct',
  _Buttons_Menu_Pop_Up_Btn_ShpRvw1: 'Buttons/Menu Pop-Up/Btn_ShpRvw1',
  _08_Downtown_Zoom_In_Peach_Building_Slct_ChrSt: '08_Downtown Zoom In/Peach Building/Slct_ChrSt',
  _Buttons_Space_Btn_Spc_Scene2: 'Buttons/Space/Btn_Spc_Scene2',
  _Buttons_Beach_Btn_Bch_Back1: 'Buttons/Beach/Btn_Bch_Back1',
  _Buttons_Camp_Btn_Cmp_Back1: 'Buttons/Camp/Btn_Cmp_Back1',
  _Buttons_City_Btn_City_Back1: 'Buttons/City/Btn_City_Back1',
  _Buttons_Space_Btn_Spc_Back1: 'Buttons/Space/Btn_Spc_Back1',
  _13_Completion_Color_Ltrs_All_Shapes_Found_P: '13_Completion/Color/Ltrs_All Shapes Found/P',
  _Buttons_Beach_Btn_Bch_Menu1: 'Buttons/Beach/Btn_Bch_Menu1',
  _Buttons_Menu_Pop_Up_Btn_Home3: 'Buttons/Menu Pop-Up/Btn_Home3',
  _Buttons_Camp_Btn_Cmp_Menu1: 'Buttons/Camp/Btn_Cmp_Menu1',
  _Buttons_Shape_Review_Btn_Menu1: 'Buttons/Shape Review/Btn_Menu1',
  _Buttons_City_Btn_City_Menu1: 'Buttons/City/Btn_City_Menu1',
  _04_Zoom_Shapes_Shp_Crcl_Ylw: '04_Zoom Shapes/Shp_Crcl_Ylw',
  _Buttons_Space_Btn_Spc_Menu1: 'Buttons/Space/Btn_Spc_Menu1',
  _04_Zoom_Shapes_Shp_Sphr: '04_Zoom Shapes/Shp_Sphr',
  _Buttons_Btn_Prgrs1: 'Buttons/Btn_Prgrs1',
  _Buttons_Btn_City_Prgrs1: 'Buttons/Btn_City_Prgrs1',
  _Buttons_Btn_Cmp_Prgrs1: 'Buttons/Btn_Cmp_Prgrs1',
  _Buttons_Btn_Spc_Prgrs1: 'Buttons/Btn_Spc_Prgrs1',
  _Buttons_Menu_Pop_Up_Btn_ShpRvw2: 'Buttons/Menu Pop-Up/Btn_ShpRvw2',
  _04_Zoom_Shapes_Shp_Sphr_Ylw: '04_Zoom Shapes/Shp_Sphr_Ylw',
  _10_Camping_Zoom_In_Truck_Slct_LcnsePl8: '10_Camping Zoom In/Truck/Slct_LcnsePl8',
  _Buttons_Print_Btn_Print1: 'Buttons/Print/Btn_Print1',
  _Buttons_New_Game_Btn_No2: 'Buttons/New Game/Btn_No2',
  _Buttons_New_Game_Btn_Yes2: 'Buttons/New Game/Btn_Yes2',
  _Pop_ups_Lock_Body: 'Pop-ups/Lock_Body',
  _04_Zoom_Shapes_Shp_Sqr: '04_Zoom Shapes/Shp_Sqr',
  _Buttons_Btn_Prgrs2: 'Buttons/Btn_Prgrs2',
  _Buttons_Shape_Review_Bgtn_Back1: 'Buttons/Shape Review/Bgtn_Back1',
  _Buttons_Shape_Review_Btn_Next2: 'Buttons/Shape Review/Btn_Next2',
  _04_Zoom_Shapes_Shp_Sqr_Ylw: '04_Zoom Shapes/Shp_Sqr_Ylw',
  _09_Camping_Star: '09_Camping/Star',
  _Buttons_Beach_Btn_Bch_Back2: 'Buttons/Beach/Btn_Bch_Back2',
  _02_Shape_Review_Title_Title_P: '02_Shape Review/Title/Title_P',
  _Buttons_Beach_Btn_Bch_Menu2: 'Buttons/Beach/Btn_Bch_Menu2',
  _Buttons_Beach_Btn_Bch_Scene1: 'Buttons/Beach/Btn_Bch_Scene1',
  _Buttons_Btn_City_Prgr2: 'Buttons/Btn_City_Prgr2',
  _Buttons_Btn_Cmp_Prgrs2: 'Buttons/Btn_Cmp_Prgrs2',
  _Buttons_Menu_Pop_Up_Btn_SndOff2: 'Buttons/Menu Pop-Up/Btn_SndOff2',
  _13_Completion_Color_Ltrs_All_Shapes_Found_F: '13_Completion/Color/Ltrs_All Shapes Found/F',
  _Buttons_Btn_Spc_Prgrs2: 'Buttons/Btn_Spc_Prgrs2',
  _Buttons_Camp_Btn_Cmp_Back2: 'Buttons/Camp/Btn_Cmp_Back2',
  _Buttons_Camp_Btn_Cmp_Menu2: 'Buttons/Camp/Btn_Cmp_Menu2',
  _Buttons_Shape_Review_Btn_Menu2: 'Buttons/Shape Review/Btn_Menu2',
  _Buttons_Camp_Btn_Cmp_Scene1: 'Buttons/Camp/Btn_Cmp_Scene1',
  _06_Menu_Pop_up_Beach_Cntr: '06_Menu Pop-up/Beach_Cntr',
  _Buttons_City_Btn_City_Back2: 'Buttons/City/Btn_City_Back2',
  _11_Space_HldngShp_Spc: '11_Space/HldngShp_Spc',
  _Buttons_City_Btn_City_Menu2: 'Buttons/City/Btn_City_Menu2',
  _Buttons_City_Btn_City_Scene1: 'Buttons/City/Btn_City_Scene1',
  _03_Beach_HldingShp_Beach: '03_Beach/HldingShp_Beach',
  _Buttons_Shape_Review_Btn_Next1: 'Buttons/Shape Review/Btn_Next1',
  _08_Downtown_Zoom_In_Blue_Building_BluBldg_Slct_Sqr2: '08_Downtown Zoom In/Blue Building/BluBldg_Slct_Sqr2',
  _05_Beach_Zoom_In_Seagull_Seagl_Slct_Beak: '05_Beach Zoom In/Seagull/Seagl_Slct_Beak',
  _Buttons_Space_Btn_Spc_Back2: 'Buttons/Space/Btn_Spc_Back2',
  _08_Downtown_Zoom_In_Blue_Building_BluBldg_Slct_Hex: '08_Downtown Zoom In/Blue Building/BluBldg_Slct_Hex',
  _09_Camping_Shrb: '09_Camping/Shrb',
  _Buttons_Space_Btn_Spc_Menu2: 'Buttons/Space/Btn_Spc_Menu2',
  _Buttons_Space_Btn_Spc_Scene1: 'Buttons/Space/Btn_Spc_Scene1',
  _Buttons_Shape_Review_Btn_Back2: 'Buttons/Shape Review/Btn_Back2',
  _06_Menu_Pop_up_Camp_Cntr: '06_Menu Pop-up/Camp_Cntr',
  _06_Menu_Pop_up_City_Cntr: '06_Menu Pop-up/City_Cntr',
  _06_Menu_Pop_up_Lock_QMark: '06_Menu Pop-up/Lock_QMark',
  _06_Menu_Pop_up_Space_Cntr: '06_Menu Pop-up/Space_Cntr',
  _10_Camping_Zoom_In_Truck_Slct_Hbcap: '10_Camping Zoom In/Truck/Slct_Hbcap',
  _12_Space_Zoom_In_Rover_Slct_Hbcap: '12_Space Zoom In/Rover/Slct_Hbcap',
  _03_Beach_HldingShp_Cmplt: '03_Beach/HldingShp_Cmplt',
  _07_Downtown_HldingShp_Dntn: '07_Downtown/HldingShp_Dntn',
  _09_Camping_HldngShp_Cmp: '09_Camping/HldngShp_Cmp',
}